import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DialogService } from './../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { BaseConsultationComponent } from '../base-consultation/base-consultation.component';
import { SaveConsultationService } from './save-consultation.service';
import { ConsultationProcessService } from '../consultation-process.service';
import { ConsultationStep } from '../../../models/consultation/consultation.model';
import { AppConstants } from '.././../../shared/constants/constants';
import { SharedService } from '../../../shared/services/share.services';
import { SaveTripType } from '../../../models/consultation/consultation.model';
import { AppMessages } from '../../../shared/constants/messages';

@Component({
  templateUrl: 'save-consultation.component.html',
  providers: [SaveConsultationService, SharedService]
})

export class SaveConsultationComponent extends BaseConsultationComponent implements OnInit, OnDestroy {
  public saveConsultationForm: FormGroup;
  public klass = 'saveConsultation';
  public isDisableAdministerVaccine = false;
  public saveTripType = SaveTripType;
  constructor(public dialogService: DialogService,
    public consultationProcessService: ConsultationProcessService,
    public router: Router,
    public activeRouter: ActivatedRoute,
    public saveConsultationService: SaveConsultationService,
    public formBuilder: FormBuilder,
    public shareServices: SharedService,
    public utility: Utility) {
    super(dialogService, consultationProcessService, router, activeRouter, ConsultationStep.SaveAndPrint);
    this.createForm();
  }

  ngOnInit() {
    // Disable Administer Vaccine option when the consultation does not have any vaccine, but they take lab test
    // call API to check this status and update to isDisableAdministerVaccine
    this.saveConsultationService.getAdministerVaccineStatus(this.filterParam.id).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.isDisableAdministerVaccine = data.status;
        }

      }
    );

  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }

  createForm() {
    this.saveConsultationForm = this.formBuilder.group({
      tripDetails: [this.saveTripType.DoNotSave, [Validators.required]],
      toDo: ['true', [Validators.required]],
      consultationSummary: [true],
      printPrescription: [true],
      printPatientCopy: [false],
    });
  }

  onChangeToDo(event) {
    //this.isDisableAdministerVaccine = (event.value == 'true');
  }

  consultationMergedReport() {
    this.saveConsultationService.isPatientHasPerscriptions(this.filterParam.id).subscribe(
      (result) => {
        if (result) {
          const reportName = 'ConsultationMerged';
          const params = {
            [AppConstants.reportParameter.historyId]: this.filterParam.id,
            [AppConstants.reportParameter.pdfprintType]: 'pdf',
            [AppConstants.reportParameter.patientCopy]: result.status,
            [AppConstants.reportParameter.consultationSummary]: this.saveConsultationForm.value.consultationSummary,
            [AppConstants.reportParameter.consultationPrescriptions]: this.saveConsultationForm.value.printPrescription,
            [AppConstants.reportParameter.consultationPatientCopy]: this.saveConsultationForm.value.printPatientCopy
          };
          this.shareServices.showReport(reportName, params);
        }
      }
    );
  }

  /**
   * over write from BaseConsultationComponent
   * save data when user click on next/prev/other step
   */
  submitData() {
    if (this.saveConsultationForm.valid && this.checkOptionChecked()) {
      // call API to save data
      const data = {
        saveTripDetail: this.saveConsultationForm.value.tripDetails,
        isPlaceInWaitingRoom: this.saveConsultationForm.value.toDo
      };
      // use this.isMoveNextStep to know if user move next or not
      this.saveConsultationService.saveConsultation(this.filterParam.id, data, this.isMoveNextStep).subscribe(
        (result) => {
          if (result) {
            const data = result.json();
            this.isDisableAdministerVaccine = data.status;
            if (this.isMoveNextStep) {
              this.consultationMergedReport();
            }
            // move to another step
            this.navigateAction();
          }
        },
        (error) => {
          if (error.status === 400) {
            this.showDataError(error.json());
          }
        }
      );
    }
  }

  /**
   * Check option checkbox is checked
   */
  checkOptionChecked() {
    if (this.saveConsultationForm.controls['consultationSummary'].value !== true &&
      this.saveConsultationForm.controls['printPrescription'].value !== true &&
      this.saveConsultationForm.controls['printPatientCopy'].value !== true) {
      this.dialogService.openErrorDialog({ message: AppMessages.consultant.errorPrintOption });
      return false;
    } else {
      return true;
    }
  }

  /**
    * over write redirect to another step in consultation
    */
  navigateAction() {
    if (this.filterParam.patientId) {
      // When no vaccine to administer for the patient and no lab test is taken,
      // display waiting room and move the patient to “Invoice” stage
      if (this.isDisableAdministerVaccine === true && this.isMoveNextStep) {
        this.router.navigate(['consultation/waiting-room']);
      } else {
        this.router.navigate([this.navigateUrl, this.filterParam.id, this.filterParam.patientId]);
      }
    } else {
      this.router.navigate([this.navigateUrl, this.filterParam.id]);
    }
  }


}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/save-consultation/save-consultation.component.ts